import { ChangeDetectionStrategy, Component, Input, OnInit, inject } from '@angular/core';
import { App } from '@df/core/app';
import { UiComponent } from '@df/ui/ui.component';
import { ICmsComponent, ICmsContent, NICmsContentField } from '@icms/core/content';
import { PaypalPayInThreeService } from './paypal-pay-in-three.service';

export namespace NPaypalPayInThreeMessageComponent {
    export const ID = 'paypal-pay-in-three-message';
    export interface IData {
        componentsId: string;
    }
}
@ICmsComponent<PaypalPayInThreeMessageComponent>({
    id: NPaypalPayInThreeMessageComponent.ID,
    block: {
        url: NPaypalPayInThreeMessageComponent.ID
    },
    onDemandOnly: true,
    name: 'Paypal Pay In Three Message',
    fields: [
        <NICmsContentField.IField>{
            key: 'componentsId',
            type: NICmsContentField.EFieldType.text,
            title: 'Components ID',
            description: 'The ID of the component to be used, example: `messages%2Cbuttons`',
            required: true
        }
    ]
})
@Component({
    selector: 'paypal-pay-in-three-message',
    templateUrl: './paypal-pay-in-three-message.html',
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class PaypalPayInThreeMessageComponent extends UiComponent implements OnInit {
    @ICmsContent({
        type: 'blockContent'
    })
    content?: NPaypalPayInThreeMessageComponent.IData;

    @Input({ required: true })
    amount!: string;
    private paypalPayInThreeService = inject(PaypalPayInThreeService);

    @Input()
    mode?: 'default' | 'basket' = 'default';

    protected app = inject(App);
    private loadedComponentsId?: string;

    private load() {
        if (!this.app.isPlatformBrowser) {
            return;
        }

        if (this.mode !== 'basket' && this.content?.componentsId) {
            this.paypalPayInThreeService.load(this.content?.componentsId);
        }
    }

    override detectChanges(): void {
        if (this.loadedComponentsId !== this.content?.componentsId) {
            this.load();
            this.loadedComponentsId = this.content?.componentsId;
        }
        super.detectChanges();
    }

    protected getBuyerCountry(): string | null {
        switch (this.app.multisite.current.country) {
            case 'US':
                return 'US';
            case 'AU':
                return 'AU';
            default:
                return null;
        }
    }
}
